import React, { useState } from 'react'
import { Link, navigate } from 'gatsby'
import slugify from 'slugify'
import CarSelectMobile from '../../modules/v1/interna/InternaGrid/CarSelectMobile'

import {
  HeaderWrapper,
  Container,
  LogoItem,
  LinkSearch,
  SearchItem,
  Navbar,
  LinkInteractiveExperience,
  BurgerMenuWrapper,
  LinksWrapper,
  MobileMenu,
  MobileMenuItem,
  ButtonSecondary
} from './styles'

import Logo from '../../assets/images/logo.svg'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { experiences } from '../../constants'

const Header = ({ model, noSearch, location, header, isNotHome, envs, basePath, modelPage, isNotFound, car }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(state => !state)

  const experience = experiences[envs?.SITE]

  const hasInteractiveExperience = model?.has_interactive_experience

  const interactiveLink = model?.experiece_class ? experience[model.experiece_class] : ''

  const breakpoints = useBreakpoint()
  const url = location?.href || ''

  const _basePath = basePath ? `/${basePath}` : ''

  const goToExperience = () => {
    if (window.gtag && car) {
      window.gtag('event', 'interactive-experience', {
        event_category: `${car[envs.CATEGORY].category_slug.toLowerCase()}-${car.car_name.toLowerCase()}`,
        event_label: window.location.href
      })
    }

    navigate(`${interactiveLink}&callback=${url}`)
  }

  return (
    <Container>
      <HeaderWrapper>
        {breakpoints.md && <div></div>}
        <LogoItem>
          <a href="#" onClick={() => navigate(isNotHome ? '/' : header?.logo_link || '/')}>
            <img src={header?.logo?.url ? `https://www.ford360guide.com${header?.logo?.url}` : Logo} alt="" />
          </a>
        </LogoItem>
        <Navbar>
          {!isNotFound && (
            <LinksWrapper>
              {model.has_expert && model.expert_link && model.expert_button_text && (
                <>
                  <LinkInteractiveExperience>
                    <a onClick={() => window.open(model.expert_link)} href="#" style={{ cursor: 'pointer' }}>
                      {model.expert_button_text.toUpperCase()}
                    </a>
                  </LinkInteractiveExperience>
                  <span style={{ borderLeft: '2px solid #00095b', marginLeft: '5px', marginRight: '5px' }}></span>
                </>
              )}

              {hasInteractiveExperience && interactiveLink && (
                <>
                  <LinkInteractiveExperience>
                    <a onClick={() => goToExperience()} href="#" style={{ cursor: 'pointer' }}>
                      {header?.experience_title_text}
                    </a>
                  </LinkInteractiveExperience>
                  <span style={{ borderLeft: '2px solid #00095b', marginLeft: '5px', marginRight: '5px' }}></span>
                </>
              )}
              <LinkInteractiveExperience>
                <a
                  onClick={() => {
                    if (window.gtag && car) {
                      window.gtag('event', 'select-another-vehicle', {
                        event_category: `${car[envs.CATEGORY].category_slug.toLowerCase()}-${car.car_name.toLowerCase()}`,
                        event_label: window.location.href
                      })
                    }

                    navigate('/')
                  }}
                  style={{ cursor: 'pointer', marginRight: '5px' }}
                >
                  {header?.change_car_text_button}
                </a>
              </LinkInteractiveExperience>
            </LinksWrapper>
          )}

          {!noSearch && (
            <LinkSearch>
              <SearchItem>
                <a
                  onClick={() => {
                    if (window.gtag && car) {
                      window.gtag('event', 'search', {
                        event_category: `${car[envs.CATEGORY].category_slug.toLowerCase()}-${car.car_name.toLowerCase()}`,
                        event_label: window.location.href
                      })
                    }

                    navigate(
                      `${_basePath}/${slugify(
                        `${model.Year_Model} ${model.Full_Name.toLowerCase().replace(`${model.Year_Model}`, '')}`
                      )}/search`
                    )
                  }}
                >
                  <span className="fds-icon fds-font--ford-icons__search"></span>
                </a>
              </SearchItem>
            </LinkSearch>
          )}
          <BurgerMenuWrapper onClick={toggle}>
            {isOpen && <span className="fds-icon fds-font--ford-icons__clear"></span>}
            {!isOpen && <span>☰</span>}
          </BurgerMenuWrapper>
        </Navbar>
      </HeaderWrapper>

      <MobileMenu isOpen={isOpen}>
        {!isNotFound && (
          <MobileMenuItem>
            <CarSelectMobile
              model={model}
              envs={envs}
              location={location}
              modelPage={modelPage}
              hasWrapper={false}
              car={car}
              isMenu
            />
          </MobileMenuItem>
        )}
        {!isNotFound && hasInteractiveExperience && (
          <MobileMenuItem>
            <ButtonSecondary style={{ marginBottom: 0, padding: 0 }}>
              {/* <Link to="https://staging.guia360ford.com.br/">{ modelPage.select_another_vehicle_text}</Link> */}
              <a onClick={() => goToExperience()} href="#" style={{ cursor: 'pointer' }}>
                <span style={{ fontSize: '20px', textTransform: 'capitalize' }}>
                  {header?.experience_title_text.toLowerCase()}
                </span>
              </a>
              <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
                <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
                <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
              </span>
            </ButtonSecondary>
          </MobileMenuItem>
        )}

        {!isNotFound && model.has_expert && model.expert_link && model.expert_button_text && (
          <MobileMenuItem>
            <ButtonSecondary style={{ marginBottom: 0, padding: 0 }}>
              {/* <Link to="https://staging.guia360ford.com.br/">{ modelPage.select_another_vehicle_text}</Link> */}
              <a onClick={() => window.open(model.expert_link)} href="#" style={{ cursor: 'pointer' }}>
                <span style={{ fontSize: '20px', textTransform: 'capitalize' }}>{model.expert_button_text.toLowerCase()}</span>
              </a>
              <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
                <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
                <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
              </span>
            </ButtonSecondary>
          </MobileMenuItem>
        )}
        {!isNotFound && (
          <MobileMenuItem>
            <ButtonSecondary style={{ marginBottom: 0, padding: 0 }}>
              <Link to="/">
                <span style={{ fontSize: '20px', textTransform: 'capitalize' }}>
                  {header?.change_car_text_button.toLowerCase()}
                </span>
              </Link>
              <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
                <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
                <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
              </span>
            </ButtonSecondary>
          </MobileMenuItem>
        )}
      </MobileMenu>
    </Container>
  )
}

export default Header
